import { partition } from "@omnia/shared/utils/array";
import { FieldViewModel } from "@omnia/types"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    holdingInNVZ: boolean;
    fields: FieldViewModel[] | undefined;
}

/** NVZ Area component. Displays information about fields in NVZ and outside. Sets class to 'nvz' (you can add more classes by className). */
export function AreaNvz({ holdingInNVZ, fields, className, ...props }: Props) {

    const [fieldsInNvz, fieldsOutOfNvz] = fields?.length > 0 ? partition(fields ?? [], f => !!f.field.NVZ) : [[], []];

    /** Returns area for the given array of fields. */
    const getArea = (fls: FieldViewModel[]) => {
        if (fls?.length == 0) {
            return 0;
        }
            
        return Math.round(fls.map(f => f?.area ?? 0).reduce((a1, a2) => a1 + a2) * 100) / 100;
    }

    /** Returns appropriate 'N fields' string form for the given fields array. */
    const getCountDescr = (fls: FieldViewModel[]) => {
        const count = fls?.length ?? 0;
        if (count > 1) return count.toString() + " fields";
        if (count == 1) return "1 field";

        return "none";
    }

    const fieldsInNvzText = fields === undefined ? '...' : `${getArea(fieldsInNvz)} ha (${getCountDescr(fieldsInNvz)})`;
    const fieldsOutOfNvzText = fields === undefined ? '...' : `${getArea(fieldsOutOfNvz)} ha (${getCountDescr(fieldsOutOfNvz)})`;

    return (       
        <div className={`${className || ''} nvz`} {...props}>

            <h4>
                NVZ
            </h4>

            <i className="icon icon-fields">
            </i>

            <div className="col">
                <span>
                    Fields in NVZ: {fieldsInNvzText}
                </span>
                <span>
                    <br /> Fields not in NVZ: {fieldsOutOfNvzText}
                </span>
            </div>

            <div className="col">

                <i className="icon icon-holding">
                </i>
                {holdingInNVZ ?
                    <span>
                        The holding <u>is in an NVZ</u>
                    </span>
                    :
                    <span>
                        The holding is not in an NVZ
                    </span>
                }

            </div>

        </div>
    );
}